export const ONLY_VIEW = 'ONLY_VIEW';
export const VIEW_AND_EDIT = 'VIEW_AND_EDIT';

export const PROJECT_PERMISSION_TYPES = [
  [ONLY_VIEW, 'Only view'],
  [VIEW_AND_EDIT, 'View & edit'],
];
